import React from 'react';

import { getIn, useFormikContext } from 'formik';

import { exportBlocker } from '../ExportPackModal';
import GeneratedPacksList from '../GeneratedPacksList';
import { useManagementPackContext } from '../ManagementPackContext';
import SavedConfigurations from '../SavedConfigurations';

import { SettingRow } from './FormField';

import ToggleInput from 'CommonComponents/ToggleInput';

const SaveAndExportTab = () => {
    const { values, errors, setFieldValue } = useFormikContext();
    const context = useManagementPackContext();
    const blocker = exportBlocker(context);

    return (
        <div className="tw-flex tw-flex-col">
            <SettingRow label={$t('Prepared by')} htmlFor="mp-prepared-by" error={getIn(errors, 'options.prepared_by')}>
                <input
                    id="mp-prepared-by"
                    type="text"
                    className="text-input tw-border-0 tw-w-full"
                    maxLength={255}
                    value={values.options.prepared_by || ''}
                    disabled={context.readOnly}
                    onChange={(event) => setFieldValue('options.prepared_by', event.target.value)}
                />
            </SettingRow>

            <SettingRow label={$t('Watermark drafts')} help={$t('"DRAFT" watermark on exports until the pack is issued')}>
                <div className="tw-flex tw-justify-end">
                    <ToggleInput
                        label={<span className="tw-sr-only">{$t('Watermark drafts')}</span>}
                        noBottomSpacing
                        checked={!!values.options.watermark_drafts}
                        disabled={context.readOnly}
                        onChange={() => setFieldValue('options.watermark_drafts', !values.options.watermark_drafts)}
                    />
                </div>
            </SettingRow>

            {blocker && <p className="tw-text-sm tw-text-charcoal-75 tw-m-0 tw-py-4 tw-border-b tw-border-charcoal-15">{blocker}</p>}

            <SavedConfigurations />
            <GeneratedPacksList />
        </div>
    );
};

export default SaveAndExportTab;
